/**
 * useLien
 * Detalle de un wallet lien por lien_id + historial paginado.
 *
 * Backend: GET /credit-worker/backoffice/liens/{lienId}
 */

import { useQuery } from '@tanstack/react-query';
import { getLienDetail } from '@/services/credit-worker.service';

export function useLien(lienId: string | undefined, pageSize = 20) {
  const query = useQuery({
    queryKey: ['lien', 'detail', lienId, pageSize],
    queryFn: () => getLienDetail(lienId!, pageSize),
    enabled: Boolean(lienId),
  });

  return {
    lien: query.data?.data?.lien ?? null,
    collections: query.data?.data?.collections ?? [],
    nextPageKey: query.data?.data?.nextPageKey ?? null,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: () => void query.refetch(),
  };
}
